import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import clipboard from '../utils/clipboard.js';
import ConfirmPopup from '../components/ConfirmPopup.js';

export default function Keys({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [oldDoorKey, setOldDoorKey] = useState({});
	const [doorKey, setDoorKey] = useState({});
	const [doorKeyUpdated, setDoorKeyUpdated] = useState({});
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);
	const [showConfirmPopup2, setShowConfirmPopup2] = useState(false);

	useEffect(() => {
		getData('');
	}, []);

	const getData = (search) => {
		setLoading(true);

		post('getKeys', {search: search})
			.then((res) => {
				setData(res.data);
				setLoading(false);

				res.data.forEach((item, index) => {
					setOldDoorKey((prevDoorKey) => ({...prevDoorKey, ['LIST_KEYS_DOORKEY_' + item.ID]: item.DOORKEY}));
					setDoorKeyUpdated((prevDoorKeyUpdated) => ({...prevDoorKeyUpdated, ['LIST_KEYS_DOORKEY_' + item.ID]: parseInt(item.DOORKEY_UPDATED)}));
				});
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const saveKey = (id) => {
		setLoading(true);

		post('saveKey', {ID: id, DOORKEY: doorKey['LIST_KEYS_DOORKEY_' + id]})
			.then((res) => {
				setLoading(false);

				setOldDoorKey({
					...oldDoorKey,
					['LIST_KEYS_DOORKEY_' + id]: doorKey['LIST_KEYS_DOORKEY_' + id],
				});

				setDoorKeyUpdated({...doorKeyUpdated, ['LIST_KEYS_DOORKEY_' + id]: 1});
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleConfirmPopup = (e) => {
		e.preventDefault();
		setShowConfirmPopup(true);
	};

	const closeConfirmPopup = () => {
		setShowConfirmPopup(false);
	};

	const cofirmConfirmPopup = () => {
		setLoading(true);

		post('saveAllNotUpdated', {})
			.then((res) => {
				setLoading(false);
				setShowConfirmPopup(false);
				getData('');
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleConfirmPopup2 = (e) => {
		e.preventDefault();
		setShowConfirmPopup2(true);
	};

	const closeConfirmPopup2 = () => {
		setShowConfirmPopup2(false);
	};

	const cofirmConfirmPopup2 = () => {
		setLoading(true);

		post('deleteAllKeys', {})
			.then((res) => {
				setLoading(false);
				setShowConfirmPopup2(false);
				getData('');
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const list = data.map((item, index) => {
		let usrName = '';
		const doorKeyFieldId = 'LIST_KEYS_DOORKEY_' + item.ID;
		const isUpdated = doorKeyUpdated[doorKeyFieldId] === 1;
		const originalDoorKey = oldDoorKey[doorKeyFieldId] || '';
		if (item.NICKNAME !== '') {
			usrName = `${item.LASTNAME} ${item.FIRSTNAME} (${item.NICKNAME})`;
		} else {
			usrName = `${item.LASTNAME} ${item.FIRSTNAME}`;
		}

		if (typeof doorKey[doorKeyFieldId] === 'undefined') {
			doorKey[doorKeyFieldId] = '';
		}

		return (
			<article className={`keys-page__row${isUpdated ? ' is-inactive' : ''}`} key={'item_' + index}>
				<div className="keys-page__row-main">
					<div className="keys-page__user-block">
						<div className="keys-page__badges">
							<img className={`icon1 member ${parseInt(item.CLUBMEMBER) === 1 ? 'active' : ''}`} alt="" />
							<img className={`icon2 permanent ${parseInt(item.PERNAMENTMEMBER) === 1 ? 'active' : ''}`} alt="" />
						</div>
						<div className="keys-page__identity">
							<button type="button" className="keys-page__user-button" onClick={() => clipboard(usrName)}>
								{usrName}
							</button>
							<button type="button" className="keys-page__door-key" onClick={() => clipboard(originalDoorKey)}>
								{originalDoorKey !== '' ? originalDoorKey : 'Žádný klíč'}
							</button>
						</div>
					</div>

					<div className="keys-page__editor">
						<label className="keys-page__editor-field" htmlFor={doorKeyFieldId}>
							<span className="keys-page__editor-label">Nový klíč</span>
							<input
								className="input-text small keys-page__input"
								id={doorKeyFieldId}
								type="text"
								value={doorKey[doorKeyFieldId] || ''}
								onChange={(e) =>
									setDoorKey({
										...doorKey,
										[doorKeyFieldId]: e.target.value,
									})
								}
							/>
						</label>

						<button type="button" className="keys-page__save-button" onClick={() => saveKey(item.ID)} aria-label={`Uložit klíč pro ${usrName}`}>
							<img className="icon1 ok1" alt="" />
						</button>
					</div>
				</div>
			</article>
		);
	});

	return (
		<>
			<div className="page_main">
				<ConfirmPopup showConfirmPopup={showConfirmPopup2} showButtonConfirm cofirmConfirmPopup={cofirmConfirmPopup2} closeConfirmPopup={closeConfirmPopup2} infoHeader="Smazání všech klíčů" infoMain="Opravdu chceš smazat klíče všem uživatelům?" />
				<ConfirmPopup showConfirmPopup={showConfirmPopup} showButtonConfirm cofirmConfirmPopup={cofirmConfirmPopup} closeConfirmPopup={closeConfirmPopup} infoHeader="Smazání záznamu" infoMain="Opravdu chceš nastavit všechny záznamy jako neupdatované?" />
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />

				<div className={`page keys-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<div className="keys-page__shell">
						<section className="keys-page__section">
							<div className="keys-page__section-head">
								<div className="keys-page__toolbar">
									<button type="button" className="keys-page__action keys-page__action--danger" onClick={(e) => handleConfirmPopup2(e)}>
										Smazat všem klíče
									</button>
									<button type="button" className="keys-page__action keys-page__action--success" onClick={(e) => handleConfirmPopup(e)}>
										Nastavit všechny jako neupdatované
									</button>
								</div>
							</div>

							<div className="keys-page__list">
								{list.length > 0 ? list : <div className="keys-page__empty">Zatím tu nejsou žádné klíče.</div>}
							</div>
						</section>
					</div>
				</div>
			</div>
		</>
	);
}
